import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import { Modal } from 'react-bootstrap';

class DeleteMapModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete() {
    this.props.sendSocketEmit({ map_id: this.props.mapCreator.deleting_map_id }, 'delete-map');
  }

  render() {
    const {
      show_deleting_map_modal,
      maps_list,
      deleting_map_id
   } = this.props.mapCreator;
   const deleting_map_obj = maps_list.find(m => m._id == deleting_map_id);
   const map_title = deleting_map_obj ? deleting_map_obj.properties.title : '';

    return (
      <Modal
        show={show_deleting_map_modal}
        onHide={this.props.cancelDeleteMap}
        >
        <div className='panel panel-danger mb-none'>
          <div className='panel-heading'>
            <h3 className='panel-title'>Are you sure?</h3>
          </div>
          <div className='panel-body'>
            <div className='row'>
              <div className='col-xs-12'>
              <p>{`Are you sure you want to delete ${map_title && map_title != '' ? `'${map_title}'?` : 'this map?' }`}</p>
              </div>
            </div>
          </div>
          <div className='panel-footer mb-none'>
            <div className='row'>
              <div className='col-xs-12'>
                <div className='col-sm-6'>
                  <div
                    onClick={this.props.cancelDeleteMap}
                    className='btn btn-block btn-default'
                    >
                    Cancel
                  </div>
                </div>
                <div className='col-sm-6'>
                  <div
                    onClick={this.handleDelete}
                    className='btn btn-block btn-danger'
                    >
                    Yes
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default mapCreatorConnect(DeleteMapModal);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/delete-map-modal.js